(function () {
  const bindScrollToProduct = () => {
    document.querySelectorAll('[data-mcamp-scroll-product]').forEach((el) => {
      if (el.dataset.mcampBound === 'true') return;
      el.dataset.mcampBound = 'true';

      el.addEventListener('click', (event) => {
        const href = el.getAttribute('href');
        if (!href || href === '#' || href === '#mcamp-scroll-product') {
          event.preventDefault();
          const productSection =
            document.querySelector('.featured-product-preview-section') ||
            document.querySelector('section.featured-product-preview');
          if (productSection) {
            productSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });
  };

  const bindFaqAccordions = () => {
    document.querySelectorAll('[data-mcamp-faq-root]').forEach((root) => {
      if (root.dataset.mcampBound === 'true') return;
      root.dataset.mcampBound = 'true';

      const allowMultiple = root.getAttribute('data-allow-multiple') === 'true';

      root.querySelectorAll('[data-mcamp-faq-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const expanded = trigger.getAttribute('aria-expanded') === 'true';
          const panelId = trigger.getAttribute('aria-controls');
          const panel = panelId ? root.querySelector('#' + CSS.escape(panelId)) : null;

          if (!allowMultiple && !expanded) {
            root.querySelectorAll('[data-mcamp-faq-trigger]').forEach((other) => {
              if (other === trigger) return;
              other.setAttribute('aria-expanded', 'false');
              const otherPanelId = other.getAttribute('aria-controls');
              const otherPanel = otherPanelId ? root.querySelector('#' + CSS.escape(otherPanelId)) : null;
              if (otherPanel) otherPanel.hidden = true;
            });
          }

          trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          if (panel) panel.hidden = expanded;
        });
      });
    });
  };

  const initMellowCampaignSections = () => {
    bindScrollToProduct();
    bindFaqAccordions();
  };

  initMellowCampaignSections();
  document.addEventListener('shopify:section:load', initMellowCampaignSections);
})();
